// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1u3Nv","buttons":"Footer_buttons__lMhYV"};